import React from "react";
import SubTitle from "../common/SubTitle";
import DashboardMapFilter from "../dashboard/DashboardMapFilter";
import { Box } from "@mui/material";
import Footer from "../common/Footer";
import MonitorSensors from "./MonitorSensors";
import { useNavigate } from "react-router";

export default function TrackAllVehicle({ isSchoolApp = false }) {
  const navigate = useNavigate();
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
    ?.name;

  const handleTripReplays = () => {
    navigate("/replay");
  };
  return (
    <>
      <SubTitle
        title={"Monitor Vehicles"}
        path={`${orgName || "organization"} > ${isSchoolApp ? "School Vehicles" : "Vehicles"
          } > Monitor Vehicles`}
        track={!isSchoolApp ? "Trip Replays" : undefined}
        onTrackClick={handleTripReplays}
      />

      <Box
        sx={{
          position: "relative",
          margin: { xs: "0px 20px 20px", md: "0px 40px 20px" },
          boxShadow: "-2px 1px 5px 1px #00000040",
          borderRadius: "10px",
          border: "1px solid #A5DCF3",
        }}
      >
        <MonitorSensors />
      </Box>

      <Box
        // className="page_container"

        sx={{
          border: "none",
          position: "relative",
          margin: { xs: "0px 20px", md: "0px 40px" },
          boxShadow: "-2px 1px 5px 1px #00000040",
          borderRadius: "10px",
          // padding: "20px",
          border: "1px solid #A5DCF3",
        }}
      >
        <DashboardMapFilter filterBy="vehicles" />
      </Box>
      <Box style={{ height: "5vh" }} />
      <Footer />
    </>
  );
}
